import { Link } from 'react-router-dom'
import MetaTags from '../components/MetaTags'
import BookingBanner from '../components/BookingBanner'

export default function ProfilePage() {
  return (
    <>
      <MetaTags
        title="Om mig - Trine Rosendal | Certificeret hypnotisør og hypnoterapeut"
        description="Jeg hedder Trine Rosendal og har siden 2007 arbejdet på fuld tid som hypnotisør og hypnoterapeut i Holstebro. Læs om min tilgang til hypnoterapi og personlige erfaring."
        image="https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/image.png"
        canonicalUrl="https://trine-rosendal.dk/profil"
      />

      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-8 sm:py-14 space-y-12 sm:space-y-16">
        {/* Breadcrumbs */}
        <nav aria-label="Brødkrummer" className="flex items-center gap-2 text-xs text-[#5C6E52]">
          <Link to="/" className="hover:text-[#222E1D] transition-colors">
            Forside
          </Link>
          <span>/</span>
          <span className="font-medium text-[#222E1D]">Profil</span>
        </nav>

        {/* Header Introduction */}
        <div className="max-w-3xl space-y-4">
          <h1 className="font-serif text-3.5xl sm:text-4xl lg:text-5xl font-medium text-[#222E1D] tracking-tight">
            Om mig
          </h1>

          <p className="text-lg sm:text-xl font-medium text-[#3E5234] leading-relaxed">
            Trine Rosendal – Certificeret hypnotisør og hypnoterapeut
          </p>
        </div>

        {/* Profile Content with Portræt */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          {/* Portrait Column */}
          <div className="lg:col-span-5 order-2 lg:order-1 lg:sticky lg:top-24 space-y-6">
            <div className="overflow-hidden rounded-3xl border border-[#D6E2CB] bg-white shadow-md">
              <img
                src="https://assets.auxodev.dk/assets/0c569b3d-b522-4d44-8ece-350bff7b17df/image.png"
                alt="Trine Rosendal portræt"
                className="w-full h-[420px] sm:h-[480px] object-cover object-top"
              />
              <div className="p-5 bg-[#F7F9F3] border-t border-[#D6E2CB] text-xs text-[#5C6E52] space-y-1">
                <p className="font-serif font-medium text-base text-[#222E1D]">Trine Rosendal</p>
                <p>Certificeret hypnotisør og hypnoterapeut</p>
                <p className="text-[11px] text-[#556D48]">Praksis i Holstebro siden 2007</p>
              </div>
            </div>

            {/* Quick Actions Card */}
            <div className="rounded-2xl border border-[#D6E2CB] bg-[#EEF3E8]/80 p-5 space-y-3">
              <a
                href="https://system.easypractice.net/book/online-booking-16"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#F5D154] hover:bg-[#EABF35] px-6 py-3.5 text-sm font-semibold text-[#1E2718] shadow-sm transition"
              >
                <i className="fa-solid fa-calendar-check text-xs" aria-hidden="true" />
                <span>Book tid hos Trine</span>
              </a>

              <Link
                to="/kontakt"
                className="w-full inline-flex items-center justify-center gap-2 rounded-full border border-[#D6E2CB] bg-white px-6 py-3 text-sm font-medium text-[#222E1D] transition hover:bg-[#FAFBF7]"
              >
                <i className="fa-solid fa-envelope text-xs text-[#556B48]" aria-hidden="true" />
                <span>Kontakt Trine</span>
              </Link>
            </div>
          </div>

          {/* Text Column with Sections */}
          <div className="lg:col-span-7 order-1 lg:order-2 space-y-8">
            {/* Intro section */}
            <div className="rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] p-7 sm:p-9 shadow-xs space-y-4 text-base sm:text-[17px] text-[#384632] leading-relaxed">
              <p>
                Jeg hedder Trine Rosendal og har siden 2007 arbejdet på fuld tid som hypnotisør og hypnoterapeut i Holstebro.
              </p>
              <p>
                Gennem årene har jeg mødt mange mennesker med hver deres historie, følelser og udfordringer.
              </p>
              <p className="font-medium text-[#222E1D]">
                Og noget af det vigtigste, jeg har lært, er, at ingen mennesker er ens.
              </p>
            </div>

            {/* Mennesket bag problematikken */}
            <div className="rounded-3xl border border-[#D6E2CB] bg-white p-7 sm:p-9 shadow-xs space-y-4 text-base sm:text-[17px] text-[#384632] leading-relaxed">
              <h2 className="font-serif text-2xl sm:text-2xl font-medium text-[#222E1D] pb-1 border-b border-[#E3EDD9]">
                Mennesket bag problematikken
              </h2>
              <p>
                Jeg har altid været meget opmærksom på mennesker, følelser og stemninger.
              </p>
              <p>
                Allerede som barn oplevede jeg, at jeg ofte fornemmede mere, end der blev sagt med ord.
              </p>
              <p>
                Den sensitivitet har fulgt mig gennem livet. Den har ikke altid været let at håndtere, men med årene har jeg lært at forstå den og bruge den konstruktivt.
              </p>
              <p>
                I dag er min intuition en naturlig del af mit arbejde, hvor jeg kombinerer den med min faglige viden og mange års erfaring.
              </p>
              <p>
                Jeg er meget bevidst om, at hvert menneske har sin egen fortid, sine egne erfaringer og sit helt eget indre liv.
              </p>
              <p className="font-medium text-[#222E1D]">
                Derfor generaliserer jeg aldrig i mine behandlinger.
              </p>
              <p>
                Selvom to mennesker kommer med de samme symptomer eller problematikker, kan det, der ligger bag, være vidt forskelligt
              </p>
            </div>

            {/* Min tilgang til hypnoterapi */}
            <div className="rounded-3xl border border-[#D6E2CB] bg-white p-7 sm:p-9 shadow-xs space-y-4 text-base sm:text-[17px] text-[#384632] leading-relaxed">
              <h2 className="font-serif text-2xl sm:text-2xl font-medium text-[#222E1D] pb-1 border-b border-[#E3EDD9]">
                Min tilgang til hypnoterapi
              </h2>
              <p>
                Når du kommer til mig, bliver du mødt med ro, nærvær og respekt.
              </p>
              <p>
                Jeg lytter, giver plads og forsøger at skabe en tryg ramme, hvor du ikke behøver at præstere eller forklare alting perfekt.
              </p>
              <p>
                Jeg arbejder individuelt og tilpasser behandlingen til præcis det menneske, jeg sidder overfor.
              </p>
              <p>
                For mig handler hypnoterapi ikke om at presse dig til at tænke anderledes eller forsøge at kontrollere dine følelser.
              </p>
              <p>
                Det handler om at skabe en større forståelse for det, der foregår indeni dig.
              </p>
              <p>
                Gennem hypnose kan vi arbejde med de ubevidste mønstre og følelsesmæssige reaktioner, som kan være svære at ændre alene gennem tankerne.
              </p>
              <p>
                Du kan lære at samarbejde med din krop, dine tanker og dine følelser i stedet for at kæmpe imod dem.
              </p>
              <p className="font-medium text-[#222E1D]">
                Og det er ofte her, forandringen begynder.
              </p>
            </div>

            {/* Mit vigtigste mål */}
            <div className="rounded-3xl border border-[#D6E2CB] bg-[#F7F9F3] p-7 sm:p-9 shadow-xs space-y-4 text-base sm:text-[17px] text-[#384632] leading-relaxed">
              <h2 className="font-serif text-2xl sm:text-2xl font-medium text-[#222E1D] pb-1 border-b border-[#D6E2CB]">
                Mit vigtigste mål
              </h2>
              <p>
                Jeg tror på, at vi mennesker allerede rummer mange af de ressourcer, vi føler, vi mangler.
              </p>
              <p>
                Men gamle oplevelser, svære følelser og ubevidste mønstre kan gøre det svært at mærke og bruge dem.
              </p>
              <p>
                Mit mål er at hjælpe dig med at finde tilbage til de ressourcer og skabe større ro, forståelse og tillid til dig selv.
              </p>
              <p>
                Jeg ønsker ikke blot, at du skal opleve en forandring under behandlingen.
              </p>
              <p>
                Jeg ønsker, at du får en større lyst til at passe på dig selv.
              </p>
              <p>
                At du finder et indre anker, som du kan holde fast i, når livet bliver svært.
              </p>
              <p>
                Og at du bliver mere selvhjulpen, så du kan fortsætte din egen udvikling.
              </p>
              <p className="font-medium text-[#222E1D]">
                For mit mål er ikke, at du skal blive ved med at have brug for mig.
              </p>
              <p className="font-medium text-[#222E1D]">
                Mit mål er, at du finder styrken og trygheden i dig selv.
              </p>
              <p>
                Jeg vil rigtig gerne hjælpe dig i den retning.
              </p>
            </div>

            {/* Call to action contact box */}
            <div className="rounded-2xl border border-[#D6E2CB] bg-[#EEF3E8] p-6 flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div className="space-y-1">
                <p className="font-medium text-[#222E1D] text-base">
                  Har du spørgsmål, er du altid meget velkommen til at kontakte mig
                </p>
                <p className="text-sm text-[#5C6E52]">
                  Jeg svarer gerne på uforpligtende spørgsmål om forløb og behandlinger.
                </p>
              </div>
              <Link
                to="/kontakt"
                className="shrink-0 inline-flex items-center gap-2 rounded-full bg-[#5C7A4F] hover:bg-[#455C3A] text-white px-5 py-2.5 text-sm font-medium transition shadow-xs"
              >
                <span>Kontakt mig</span>
                <i className="fa-solid fa-arrow-right text-xs" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>

        <BookingBanner />
      </div>
    </>
  )
}
